module.exports = __webpack_public_path__ + "img/image_header-round-parts_01.eb283f85.svg";